import React, { Component } from 'react';
import PropTypes from 'prop-types';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var daysInMonth = function daysInMonth(y, m) {
  return new Date(y, m, 0).getDate();
};

var isLeapYear = function isLeapYear(y) {
  return daysInMonth(2, y) === 29;
};

var str2dmyList = function str2dmyList(str) {
  return str.split(/-|\//ig).map(function (s) {
    return parseInt(s);
  });
};

var str2dmy = function str2dmy(str) {
  return str2dmyList(str).reduce(function (o, v, i) {
    i === 0 ? o['d'] = v : i === 1 ? o['m'] = v : o['y'] = v;
    return o;
  }, {});
};

var dmy2str = function dmy2str(_ref) {
  var d = _ref.d,
      m = _ref.m,
      y = _ref.y;
  return (d < 10 && '0' + d || d) + '/' + (m < 10 && '0' + m || m) + '/' + y;
};

var date2dmy = function date2dmy(d) {
  return {
    d: d.getDate(),
    m: d.getMonth() + 1,
    y: d.getFullYear()
  };
};

var isValideDate = function isValideDate(str) {
  if (/((0[1-9]|[12]\d|3[01])-(0[1-9]|1[0-2])-[12]\d{3})/.test(str) || /((0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/[12]\d{3})/.test(str)) {
    var _str2dmyList = str2dmyList(str),
        _str2dmyList2 = _slicedToArray(_str2dmyList, 3),
        d = _str2dmyList2[0],
        m = _str2dmyList2[1],
        y = _str2dmyList2[2];

    if (m === 2) {
      var isLeap = isLeapYear(y);
      return !(!isLeap && d > 28 || isLeap && d > 29);
    }

    return true;
  }

  return false;
};

var dateFormater = function dateFormater(date) {
  if (typeof date === "string") {
    if (isValideDate(date)) {
      return str2dmy(date);
    }
  } else if (date instanceof Date) {
    return date2dmy(date);
  }

  throw new Error("Unvalid date format. try with: dd-mm-yyyy or dd/mm/yyyy");
};

var months = {
  en: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  fr: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
  es: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
  de: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
  it: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"]
};
var days = {
  en: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  fr: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
  es: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"],
  de: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  it: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"]
};

var addMonth = function addMonth(_ref2) {
  var d = _ref2.d,
      m = _ref2.m,
      y = _ref2.y;
  return m === 12 ? {
    d: d,
    m: 1,
    y: y + 1
  } : {
    d: d,
    m: m + 1,
    y: y
  };
};

var subMonth = function subMonth(_ref3) {
  var d = _ref3.d,
      m = _ref3.m,
      y = _ref3.y;
  return m === 1 ? {
    d: d,
    m: 12,
    y: y - 1
  } : {
    d: d,
    m: m - 1,
    y: y
  };
};

var addYear = function addYear(_ref4) {
  var d = _ref4.d,
      m = _ref4.m,
      y = _ref4.y;
  return {
    d: d,
    m: m,
    y: y + 1
  };
};

var subYear = function subYear(_ref5) {
  var d = _ref5.d,
      m = _ref5.m,
      y = _ref5.y;
  return {
    d: d,
    m: m,
    y: y - 1
  };
};

var toCamelCase = function toCamelCase(str) {
  return str.replace(/-([a-z])/ig, function (all, l) {
    return l.toUpperCase();
  });
};

var parseCSS = function parseCSS(css) {
  var cssObject = {};
  var cssProps = css.trim().split(";");
  cssProps[cssProps.length - 1] === "" && cssProps.pop();
  var length = cssProps.length,
      prop_val;

  for (var i = 0; i < length; i++) {
    prop_val = cssProps[i].split(":");
    if (prop_val.length !== 2) ;
    cssObject[toCamelCase(prop_val[0].trim())] = prop_val[1].trim();
  }

  return cssObject;
};

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');\n\n:root{\n  --box-shadow-color: rgba(33, 33, 33, 0.5);\n}\n\n.styles_light_theme__dKi9W{\n  --main-color: rgb(245, 245, 245);\n  --light-main-color: rgb(254, 254, 254);\n  --second-color: rgba(54, 54, 54, 1);\n  --day-bg-color: rgba(154, 154, 154, 0.1);\n  --border-color: rgba(154, 154, 154, 0.5);\n  --control-background: rgba(33, 33, 33, 0.15);\n}\n\n.styles_dark_theme__mzF4J{\n  --main-color: rgb(26, 26, 26);\n  --light-main-color: rgb(36, 36, 37);\n  --second-color: rgb(195, 195, 195);\n  --day-bg-color: rgba(0, 0, 0, 0.1);\n  --border-color: rgba(0, 0, 0, 0.5);\n  --control-background: rgba(255, 255, 255, 0.15);\n}\n\n.styles_react_datepickerrz__2K68A  * {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  font-family: 'Roboto', sans-serif;\n}\n\n.styles_react_datepickerrz__2K68A  *::selection{\n  background: transparent\n}\n\n.styles_icons__9UH95 {\n  fill: var(--second-color);\n}\n\n.styles_react_datepickerrz_container__2CrF- {\n  display: flex;\n}\n\n.styles_react_datepickerrz__2K68A {\n  position: relative;\n}\n\n.styles_react_datepickerrz__2K68A  .styles_input_field__1-J28::selection{\n  background-color: var(--second-color);\n  color: var(--main-color)\n}\n\n.styles_react_datepickerrz__2K68A  .styles_input_field__1-J28{\n  padding: 5px 0px;\n  border: 1px solid var(--border-color);\n  background-color: var(--main-color);\n  color: var(--second-color);\n  font-size: 15px;\n  border-radius: 3px;\n  outline: none;\n  width: 210px;\n  text-align: center;\n  box-shadow: var(--box-shadow-color) 0px 0px 4px -2px;\n}\n\n.styles_react_datepickerrz__2K68A  .styles_calander_container__1jhZv {\n  display: inline-flex;\n  flex-direction: column;\n  width: 100%;\n  min-width: 180px;\n  position: absolute;\n  top: 50px;\n  left: 0px;\n  border: 1px solid var(--border-color);\n  background-color: var(--main-color);\n  font-size: 15px;\n  border-radius: 3px;\n  box-shadow: var(--box-shadow-color) 0px 0px 4px -2px;\n}\n\n.styles_react_datepickerrz__2K68A  .styles_calander_header_container__1Tv-Y .styles_cart__2UjaV{\n  display: block;\n  content: '';\n  width: 16px;\n  height: 16px;\n  background-color: var(--main-color);\n  border-left: 1px solid var(--border-color);\n  border-top: 1px solid var(--border-color);\n  border-top-left-radius: 3px;\n  position: absolute;\n  left: calc(50% - 6px);\n  top: -9px;\n  transform: rotate(45deg);\n  box-shadow: var(--box-shadow-color) -1px -1px 2px -2px;\n}\n\n.styles_react_datepickerrz__2K68A  .styles_calander_header_container__1Tv-Y {\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n  color: var(--second-color);\n  height: 60px;\n  padding: 5px;\n  border-radius: 3px;\n  box-shadow: var(--box-shadow-color) 0px 2px 2px -2px;\n  z-index: 2;\n}\n\n.styles_react_datepickerrz__2K68A  .styles_calander_header_container__1Tv-Y .styles_control__12XFx,\n.styles_react_datepickerrz__2K68A  .styles_calander_header_container__1Tv-Y .styles_week_days__2wRm6 {\n  display: flex;\n  height: 30px;\n}\n\n.styles_react_datepickerrz__2K68A  .styles_calander_header_container__1Tv-Y .styles_control__12XFx .styles_prev__2OWWh,\n.styles_react_datepickerrz__2K68A  .styles_calander_header_container__1Tv-Y .styles_control__12XFx .styles_next___68Hz{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 10%;\n  height: 100%;\n}\n\n.styles_react_datepickerrz__2K68A  .styles_calander_header_container__1Tv-Y .styles_control__12XFx .styles_prev__2OWWh svg,\n.styles_react_datepickerrz__2K68A  .styles_calander_header_container__1Tv-Y .styles_control__12XFx .styles_next___68Hz svg{\n  display: block;height: 10px;\n  width: 10px;\n}\n\n.styles_react_datepickerrz__2K68A  .styles_calander_header_container__1Tv-Y .styles_control__12XFx .styles_display__1hUDz {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  width: 60%;\n}\n\n.styles_react_datepickerrz__2K68A  .styles_calander_header_container__1Tv-Y .styles_control__12XFx .styles_display__1hUDz p{\n  font-size: 13px;\n}\n\n.styles_react_datepickerrz__2K68A  .styles_calander_header_container__1Tv-Y .styles_control__12XFx .styles_display__1hUDz .styles_month__22P6g,\n.styles_react_datepickerrz__2K68A .styles_calander_header_container__1Tv-Y .styles_control__12XFx .styles_display__1hUDz .styles_year__JYf-_{\n  display: flex;\n  height: 100%;\n  justify-content:center;\n  align-items: center;\n  padding: 0 5px;\n}\n\n.styles_react_datepickerrz__2K68A .styles_calander_header_container__1Tv-Y .styles_control__12XFx .styles_prev__2OWWh,\n.styles_react_datepickerrz__2K68A .styles_calander_header_container__1Tv-Y .styles_control__12XFx .styles_next___68Hz{\n  margin: 0 1px;\n  border-radius: 2px;\n  cursor: pointer;\n  transition: all 250ms ease;\n}\n\n.styles_react_datepickerrz__2K68A .styles_calander_header_container__1Tv-Y .styles_control__12XFx .styles_prev__2OWWh:hover,\n.styles_react_datepickerrz__2K68A .styles_calander_header_container__1Tv-Y .styles_control__12XFx .styles_next___68Hz:hover{\n  background-color: var(--control-background);\n}\n\n.styles_react_datepickerrz__2K68A .styles_calander_header_container__1Tv-Y .styles_week_days__2wRm6{\n  justify-content: space-around;\n  align-items: center;\n}\n\n.styles_react_datepickerrz__2K68A .styles_calander_header_container__1Tv-Y .styles_week_days__2wRm6 .styles_w-day__2p4u_{\n  width: calc(100% / 8);\n  text-align: center;\n  font-size: 12px;\n  padding: 3px;\n  border-radius: 3px;\n}\n\n.styles_react_datepickerrz__2K68A .styles_calander_body_container__2Frbc {\n  display: flex;\n  background-color: var(--light-main-color);\n  width: 100%;\n  padding: 5px;\n}\n\n.styles_react_datepickerrz__2K68A .styles_calander_body_container__2Frbc .styles_days_container__s1b1j{\n  display: flex;\n  flex-wrap: wrap;\n  position: relative;\n  width: 100%;\n}\n\n.styles_react_datepickerrz__2K68A .styles_calander_body_container__2Frbc .styles_days_container__s1b1j .styles_day__1cspH {\n  display: flex;\n  width: calc((100% / 7) - 2px);  \n  margin: 1px\n}\n\n.styles_react_datepickerrz__2K68A .styles_calander_body_container__2Frbc .styles_days_container__s1b1j .styles_day__1cspH:before {\n  content: \"\";\n  display: block;\n  padding-top: 100%;\n}\n\n.styles_react_datepickerrz__2K68A .styles_calander_body_container__2Frbc .styles_days_container__s1b1j .styles_day__1cspH .styles_day_contianer__eBKFp{\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  cursor: pointer;\n  border-radius: 3px;\n  border: 1px solid transparent;\n  transition: all 250ms ease;\n}\n\n.styles_react_datepickerrz__2K68A .styles_calander_body_container__2Frbc .styles_days_container__s1b1j .styles_day__1cspH .styles_day_contianer__eBKFp:hover{\n  background-color: var(--day-bg-color);\n  border: 1px solid var(--border-color);\n  box-shadow: var(--box-shadow-color) 0px 0px 2px 0px;\n}\n\n.styles_react_datepickerrz__2K68A .styles_calander_body_container__2Frbc .styles_days_container__s1b1j .styles_day__1cspH .styles_day_text__2siCM {\n  color: var(--second-color);\n  font-size: 13px;    \n  transition: 250ms ease forwards\n}\n\n.styles_react_datepickerrz__2K68A .styles_calander_body_container__2Frbc .styles_days_container__s1b1j .styles_day__1cspH.styles_active__3G4VH .styles_day_text__2siCM{\n  color: var(--main-color);\n}\n\n.styles_react_datepickerrz__2K68A .styles_calander_body_container__2Frbc .styles_days_container__s1b1j .styles_day__1cspH.styles_active__3G4VH .styles_day_contianer__eBKFp{\n  border: 1px solid var(--border-color);\n  box-shadow: var(--box-shadow-color) 0px 0px 2px 0px;\n}";
var styles = {
  "light_theme": "styles_light_theme__dKi9W",
  "dark_theme": "styles_dark_theme__mzF4J",
  "react_datepickerrz": "styles_react_datepickerrz__2K68A",
  "icons": "styles_icons__9UH95",
  "react_datepickerrz_container": "styles_react_datepickerrz_container__2CrF-",
  "input_field": "styles_input_field__1-J28",
  "calander_container": "styles_calander_container__1jhZv",
  "calander_header_container": "styles_calander_header_container__1Tv-Y",
  "cart": "styles_cart__2UjaV",
  "control": "styles_control__12XFx",
  "week_days": "styles_week_days__2wRm6",
  "prev": "styles_prev__2OWWh",
  "next": "styles_next___68Hz",
  "display": "styles_display__1hUDz",
  "month": "styles_month__22P6g",
  "year": "styles_year__JYf-_",
  "w-day": "styles_w-day__2p4u_",
  "calander_body_container": "styles_calander_body_container__2Frbc",
  "days_container": "styles_days_container__s1b1j",
  "day": "styles_day__1cspH",
  "day_contianer": "styles_day_contianer__eBKFp",
  "day_text": "styles_day_text__2siCM",
  "active": "styles_active__3G4VH"
};
styleInject(css_248z);

var DateInput = /*#__PURE__*/function (_Component) {
  _inherits(DateInput, _Component);

  var _super = _createSuper(DateInput);

  function DateInput(props) {
    var _this;

    _classCallCheck(this, DateInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (e) {
      var value = e.target.value;

      _this.setState(function (state) {
        return {
          inputValue: value
        };
      }, function () {
        var onDateChange = _this.props.onDateChange;

        if (value.length === 10) {
          try {
            var date = dateFormater(value);
            onDateChange(date);
          } catch (error) {
            onDateChange(dateFormater(new Date()));
          }
        }
      });
    });

    var _this$props = _this.props,
        _date = _this$props.date,
        inputStyle = _this$props.inputStyle;
    _this.state = {
      inputStyle: inputStyle,
      date: _date,
      inputValue: dmy2str(_date)
    };
    return _this;
  }

  _createClass(DateInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps !== this.props) {
        var _this$props2 = this.props,
            date = _this$props2.date,
            inputStyle = _this$props2.inputStyle;
        this.setState(function (state) {
          return {
            date: date,
            inputValue: dmy2str(date),
            inputStyle: inputStyle
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var onInputFocus = this.props.onInputFocus;
      var _this$state = this.state,
          inputStyle = _this$state.inputStyle,
          inputValue = _this$state.inputValue;
      return /*#__PURE__*/React.createElement("input", {
        className: styles.input_field,
        onFocus: onInputFocus,
        onChange: this.onInputChange,
        type: "text",
        value: inputValue,
        style: inputStyle,
        maxLength: "10",
        placeholder: "dd/mm/yyyy"
      });
    }
  }]);

  return DateInput;
}(Component);

DateInput.propTypes = {
  inputStyle: PropTypes.object.isRequired,
  onDateChange: PropTypes.func.isRequired,
  date: PropTypes.object.isRequired,
  onInputFocus: PropTypes.func.isRequired
};

var Arrow = /*#__PURE__*/function (_Component) {
  _inherits(Arrow, _Component);

  var _super = _createSuper(Arrow);

  function Arrow() {
    _classCallCheck(this, Arrow);

    return _super.apply(this, arguments);
  }

  _createClass(Arrow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          left = _this$props.left,
          _double = _this$props["double"];
      return /*#__PURE__*/React.createElement(React.Fragment, null, _double ? /*#__PURE__*/React.createElement("svg", {
        className: styles.icons,
        x: "0px",
        y: "0px",
        viewBox: "0 0 480 480",
        style: left ? {
          transform: 'rotate(180deg)'
        } : {}
      }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
        d: "M475.922,229.325l-144-160c-3.072-3.392-7.36-5.312-11.904-5.312h-96c-6.304,0-12.032,3.712-14.624,9.472 c-2.56,5.792-1.504,12.544,2.72,17.216l134.368,149.312l-134.368,149.28c-4.224,4.704-5.312,11.456-2.72,17.216 c2.592,5.792,8.32,9.504,14.624,9.504h96c4.544,0,8.832-1.952,11.904-5.28l144-160 C481.394,244.653,481.394,235.373,475.922,229.325z"
      }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
        d: "M267.922,229.325l-144-160c-3.072-3.392-7.36-5.312-11.904-5.312h-96c-6.304,0-12.032,3.712-14.624,9.472 c-2.56,5.792-1.504,12.544,2.72,17.216l134.368,149.312L4.114,389.293c-4.224,4.704-5.312,11.456-2.72,17.216 c2.592,5.792,8.32,9.504,14.624,9.504h96c4.544,0,8.832-1.952,11.904-5.28l144-160 C273.394,244.653,273.394,235.373,267.922,229.325z"
      })))) : /*#__PURE__*/React.createElement("svg", {
        className: styles.icons,
        x: "0px",
        y: "0px",
        viewBox: "0 0 240 480",
        style: left ? {
          transform: 'rotate(180deg)'
        } : {}
      }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
        d: "M267.922,229.325l-144-160c-3.072-3.392-7.36-5.312-11.904-5.312h-96c-6.304,0-12.032,3.712-14.624,9.472 c-2.56,5.792-1.504,12.544,2.72,17.216l134.368,149.312L4.114,389.293c-4.224,4.704-5.312,11.456-2.72,17.216 c2.592,5.792,8.32,9.504,14.624,9.504h96c4.544,0,8.832-1.952,11.904-5.28l144-160 C273.394,244.653,273.394,235.373,267.922,229.325z"
      }))));
    }
  }]);

  return Arrow;
}(Component);

Arrow.defaultProps = {
  left: false,
  "double": false
};
Arrow.propTypes = {
  left: PropTypes.bool,
  "double": PropTypes.bool
};

var CalanderHead = /*#__PURE__*/function (_Component) {
  _inherits(CalanderHead, _Component);

  var _super = _createSuper(CalanderHead);

  function CalanderHead() {
    _classCallCheck(this, CalanderHead);

    return _super.apply(this, arguments);
  }

  _createClass(CalanderHead, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          date = _this$props.date,
          lang = _this$props.lang,
          onDateChange = _this$props.onDateChange;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.calander_header_container
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.cart
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.control
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.prev, " ").concat(styles.year),
        onClick: function onClick() {
          return onDateChange(subYear(date));
        }
      }, /*#__PURE__*/React.createElement(Arrow, {
        left: true,
        "double": true
      })), /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.prev, " ").concat(styles.month),
        onClick: function onClick() {
          return onDateChange(subMonth(date));
        }
      }, /*#__PURE__*/React.createElement(Arrow, {
        left: true
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.display
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.month
      }, /*#__PURE__*/React.createElement("p", null, months[lang][date.m - 1])), /*#__PURE__*/React.createElement("div", {
        className: styles.year
      }, /*#__PURE__*/React.createElement("p", null, date.y))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.next, " ").concat(styles.month),
        onClick: function onClick() {
          return onDateChange(addMonth(date));
        }
      }, /*#__PURE__*/React.createElement(Arrow, null)), /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.next, " ").concat(styles.year),
        onClick: function onClick() {
          return onDateChange(addYear(date));
        }
      }, /*#__PURE__*/React.createElement(Arrow, {
        "double": true
      }))), /*#__PURE__*/React.createElement("div", {
        className: styles.week_days
      }, days[lang].map(function (day, i) {
        return /*#__PURE__*/React.createElement("p", {
          key: i,
          className: styles.w_day
        }, day);
      })));
    }
  }]);

  return CalanderHead;
}(Component);

CalanderHead.propTypes = {
  date: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  onDateChange: PropTypes.func.isRequired
};

var CalanderBody = /*#__PURE__*/function (_Component) {
  _inherits(CalanderBody, _Component);

  var _super = _createSuper(CalanderBody);

  function CalanderBody(props) {
    var _this;

    _classCallCheck(this, CalanderBody);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "renderEmptyDays", function () {
      var firstDay = _this.state.firstDay;
      var empty = [];

      for (var i = 0; i < firstDay; i++) {
        empty.push( /*#__PURE__*/React.createElement("div", {
          key: i,
          className: "".concat(styles.day, " ").concat(styles.empty)
        }, /*#__PURE__*/React.createElement("p", null)));
      }

      return empty;
    });

    _defineProperty(_assertThisInitialized(_this), "renderDays", function () {
      var _this$props = _this.props,
          onDateChange = _this$props.onDateChange,
          activeColor = _this$props.activeColor;
      var _this$state = _this.state,
          daysCount = _this$state.daysCount,
          date = _this$state.date;
      var days = [];

      var _loop = function _loop(i) {
        days.push( /*#__PURE__*/React.createElement("div", {
          key: i,
          onClick: function onClick() {
            return onDateChange(_objectSpread2(_objectSpread2({}, date), {}, {
              d: i + 1
            }));
          },
          className: "".concat(styles.day, " ").concat(i + 1 === date.d ? styles.active : "")
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.day_contianer,
          style: i + 1 === date.d ? {
            backgroundColor: activeColor
          } : {}
        }, /*#__PURE__*/React.createElement("p", {
          className: styles.day_text
        }, i + 1))));
      };

      for (var i = 0; i < daysCount; i++) {
        _loop(i);
      }

      return days;
    });

    var _date = _this.props.date;
    _this.state = {
      date: _date,
      firstDay: new Date(_date.y, _date.m - 1, 1).getDay(),
      daysCount: daysInMonth(_date.y, _date.m)
    };
    return _this;
  }

  _createClass(CalanderBody, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps !== this.props) {
        var date = this.props.date;
        this.setState(function (state) {
          return {
            date: date,
            firstDay: new Date(date.y, date.m - 1, 1).getDay(),
            daysCount: daysInMonth(date.y, date.m)
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.calander_body_container
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.days_container
      }, this.renderEmptyDays(), this.renderDays()));
    }
  }]);

  return CalanderBody;
}(Component);

CalanderBody.propTypes = {
  date: PropTypes.object.isRequired,
  onDateChange: PropTypes.func.isRequired
};

var Calander = /*#__PURE__*/function (_Component) {
  _inherits(Calander, _Component);

  var _super = _createSuper(Calander);

  function Calander() {
    _classCallCheck(this, Calander);

    return _super.apply(this, arguments);
  }

  _createClass(Calander, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          date = _this$props.date,
          lang = _this$props.lang,
          onDateChange = _this$props.onDateChange,
          display = _this$props.display,
          activeColor = _this$props.activeColor;
      return /*#__PURE__*/React.createElement(React.Fragment, null, display && /*#__PURE__*/React.createElement("div", {
        className: styles.calander_container
      }, /*#__PURE__*/React.createElement(CalanderHead, {
        lang: lang,
        date: date,
        onDateChange: onDateChange
      }), /*#__PURE__*/React.createElement(CalanderBody, {
        date: date,
        onDateChange: onDateChange,
        activeColor: activeColor
      })));
    }
  }]);

  return Calander;
}(Component);

Calander.propTypes = {
  display: PropTypes.bool.isRequired,
  date: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  onDateChange: PropTypes.func.isRequired
};

var DatePicker = /*#__PURE__*/function (_Component) {
  _inherits(DatePicker, _Component);

  var _super = _createSuper(DatePicker);

  function DatePicker(props) {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (date) {
      var onPickDate = _this.props.onPickDate;
      var d = date.d,
          m = date.m,
          y = date.y;
      var pickedDate = {
        day: d,
        month: m,
        year: y,
        date: new Date("".concat(y, "/").concat(m, "/").concat(d))
      };

      _this.setState(function (state) {
        return {
          date: date
        };
      }, function () {
        return onPickDate(pickedDate);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onInputFocus", function () {
      _this.setState(function (state) {
        return {
          isInputFocus: true
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "hideCalander", function (e) {
      if (_this.datepickerRef.current && !_this.datepickerRef.current.contains(e.target)) {
        _this.setState(function (state) {
          return {
            isInputFocus: false
          };
        });
      }
    });

    var _this$props = _this.props,
        _date = _this$props.date,
        inputStyle = _this$props.inputStyle;
    _this.state = {
      date: typeof _date === "string" ? str2dmy(_date) : date2dmy(_date),
      isInputFocus: false,
      inputStyle: inputStyle
    };
    _this.datepickerRef = React.createRef();
    return _this;
  }

  _createClass(DatePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("click", this.hideCalander, true);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (prevProps !== this.props) {
        this.setState(function (state) {
          return {
            inputStyle: _this2.props.inputStyle
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          lang = _this$props2.lang,
          activeColor = _this$props2.activeColor,
          dark = _this$props2.dark;
      var _this$state = this.state,
          date = _this$state.date,
          inputStyle = _this$state.inputStyle;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.react_datepickerrz_container
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.datepickerRef,
        className: "".concat(styles.react_datepickerrz, " ").concat(dark ? styles.dark_theme : styles.light_theme)
      }, /*#__PURE__*/React.createElement(DateInput, {
        onInputFocus: this.onInputFocus,
        date: date,
        inputStyle: parseCSS(inputStyle),
        onDateChange: this.onDateChange
      }), /*#__PURE__*/React.createElement(Calander, {
        display: this.state.isInputFocus,
        lang: lang,
        date: date,
        onDateChange: this.onDateChange,
        activeColor: activeColor
      })));
    }
  }]);

  return DatePicker;
}(Component);

DatePicker.defaultProps = {
  inputStyle: "",
  activeColor: '#119955',
  dark: false,
  date: new Date(),
  lang: "en"
};
DatePicker.propTypes = {
  inputStyle: PropTypes.string,
  activeColor: PropTypes.string,
  dark: PropTypes.bool,
  date: PropTypes.string || PropTypes.instanceOf(Date),
  lang: PropTypes.string,
  onPickDate: PropTypes.func.isRequired
};
export default DatePicker;